// Port of api/fuel/app/classes/insights/ratings/years.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'

export default Segment.extend({
	name: 'years',
	insight: ['year'],
	run: function(type, owner, userIndex, detail, filter) {

		if (!owner.get_count_collection()) return {}

		var limit = detail ? 100000 : 25
		var yearType = (filter.year !== undefined) ? filter.year : 'version'
		var years = {}
		var currentYear = new Date().getUTCFullYear()

		for (var i = currentYear; i > currentYear - limit; i--) {
			years[i] = {
				year: i,
				count: 0,
				rating: 0
			}
		}

		var ratingIndex = Util.query(
			'SELECT g.game_published AS gy, v.game_version_year AS vy, r.rating_value AS rv' +
			' FROM (rating r JOIN game g ON r.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON r.game_version_id = v.game_version_id' +
			' WHERE r.user_id IN (' + Util.in(userIndex) + ')' +
			' AND g.game_type = 1' +
			' GROUP BY g.game_id, v.game_version_id'
		)

		var earliestYear = detail ? currentYear : currentYear - limit

		for (var ri = 0; ri < ratingIndex.length; ri++) {
			var item = ratingIndex[ri]
			var year = (item.vy && yearType === 'version') ? parseInt(item.vy, 10) : parseInt(item.gy, 10)

			if (years[year] !== undefined) {
				years[year].count++
				years[year].rating += parseFloat(item.rv)
			}

			if (earliestYear > year && (!detail || (detail && year > currentYear - limit))) {
				earliestYear = year
			}
		}

		var yearsArray = Util.sort_by_field(Object.keys(years).map(function(key) {
			return years[key]
		}), 'year', 'desc')

		yearsArray = yearsArray.filter(function(item) {
			return item.year >= earliestYear && (item.count > 0 || item.year > (currentYear - 25))
		})

		return {
			years: yearsArray,
			moreYears: (!detail && earliestYear < currentYear - limit + 1) ? true : false
		}

	}
})
